import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/commmune-online-customer.jpg'

const paperInfo = {
  paperName: 'オンライン顧客接点 うちもやらなきゃ！を考えた担当者がまず読む本',
  thumbnail,
  feature1: 'なぜいまオンライン顧客接点が重要なのか',
  feature2: 'どのようにオンライン顧客接点を実現するのか',
  feature3: 'With コロナ時代におけるオンライン顧客接点への移行事例',
  description:
    '新型コロナウイルス感染拡大の影響により、早急な見直しが必要とされる顧客接点。オンライン顧客接点がなぜ今重要なのか、そして企業はどうすべきなのか、について豊富な事例をもとに解説いたします。',
  formSrc: 'https://go.commmune.jp/l/915341/2021-03-06/g85',
  type: 'pardot' // TODO: HubSpotからPardotに移行したらこのタグ付けが不要になるので削除する
}

const WhitePaperPage = () => {
  return <PaperPage {...paperInfo} />
}

export default WhitePaperPage
